// extracted by mini-css-extract-plugin
export default {"report_btn_container":"ModalReportPost_report_btn_container__tQUsG","report_title":"ModalReportPost_report_title__Hxsx4"};